<div class="cart-awb w-100">
    <mat-expansion-panel [expanded]="panelOpenState" (opened)="onPanelOpen()" (closed)="onPanelClose()" class="w-100">
        <mat-expansion-panel-header aria-label="Toggle panel" class="d-flex justify-content-between header">
            <div class="mat-subtitle-1 m-0 title">AWB: {{ awb }}</div>
        </mat-expansion-panel-header>
        @if (panelOpenState) {
            <div class="info">
                @for (
                    flightPayments of flights;
                    let flightPaymentsIndex = $index;
                    track flightPaymentsIndex;
                    let index = $index;
                    let isFirst = $first
                ) {
                    @if (!isFirst) {
                        <mat-divider class="mb-1" />
                    }
                    <div class="w-100">
                        <app-flight-section
                            [index]="index"
                            [panelOpen]="panelOpenState"
                            [flightPayments]="flightPayments"
                            [aboveThreshold]="aboveThreshold"
                            [awb]="awb"
                        />
                    </div>
                }
                @if (nonReservationFee || (newFees && newFees.length)) {
                    <div class="fee-by-awb-section w-100">
                        <div
                            class="d-flex flex-column-reverse flex-md-row justify-content-between align-items-center w-100"
                        >
                            <div class="promo-code-section me-2">
                                @if (!!nonReservationFee) {
                                    <app-promo-code
                                        class="w-100"
                                        [awbNumber]="awb"
                                        [awbList]="awbList"
                                        (eventOnOpenDropDown)="onOpenCloseDropDown()"
                                        (eventOnCloseDropDown)="onOpenCloseDropDown()"
                                    />
                                }
                            </div>
                            <div class="fees-by-awb">
                                @if (newFees && newFees.length) {
                                    <div class="d-flex flex-column item-data">
                                        @for (fee of newFees; let feeIndex = $index; track feeIndex) {
                                            <div class="d-flex align-items-center">
                                                <app-fee
                                                    class="w-100"
                                                    [feeLabel]="fee.feeLabel"
                                                    [feeValue]="fee.feeValue"
                                                    [fontClassLabel]="'mat-caption item-data__title'"
                                                    [fontClassValue]="'mat-caption item-data__value'"
                                                />
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </mat-expansion-panel>
</div>
